export const flattenFacturas = (facturas) => facturas.map(factura => ({
    ...factura,
    id_cuenta: factura.cuenta.id_cuenta,
    tipoCuenta: factura.cuenta.tipoCuenta,
    impuesto: factura.impuesto || '',
}));
//1 y 3 son "impagas" el resto "canceladas"
